/** Czytelne nazwy filtrów i tagów Historie Messenger (dla operatora, nie analityka). */

export type LabelWithHint = { label: string; hint: string };

export const MESSENGER_CLASS_LABELS: Record<string, LabelWithHint> = {
  historia_identyfikacja: {
    label: "Historia z życia",
    hint: "Długa opowieść o relacji z matką, traumie, codziennym życiu",
  },
  produkt_zakup: {
    label: "Produkt lub zakup",
    hint: "Pytanie o książkę, pakiet, cenę, jak zamówić",
  },
  pytanie: {
    label: "Pytanie",
    hint: "Szuka rady lub wyjaśnienia, bez pełnej historii",
  },
  wsparcie: {
    label: "Wdzięczność / wsparcie",
    hint: "Dziękuje, wspiera Kasię, poleca treści",
  },
  atak_forma: {
    label: "Krytyka / ostry ton",
    hint: "Ostra wymiana, niezgodzenie, twardy język",
  },
  obrona_matek: {
    label: "Obrona matek",
    hint: "Broni dobrej matki, dystans do „wszystkie matki takie”",
  },
  cta_only: {
    label: "Samo hasło / CTA",
    hint: "Krótkie hasło pod rolką (np. MAMA), bez treści",
  },
  krotka_reakcja: {
    label: "Krótka reakcja",
    hint: "Bardzo krótka wiadomość bez historii",
  },
  inne: {
    label: "Inne",
    hint: "Nie pasuje do pozostałych kategorii",
  },
  empty: {
    label: "Pusta / załącznik",
    hint: "Brak tekstu (karta, zdjęcie, system Meta)",
  },
};

export const MESSENGER_PERSONA_LABELS: Record<string, LabelWithHint> = {
  P1: {
    label: "Dorosła córka",
    hint: "Pisze jako córka; matka jest ważnym tematem",
  },
  P2: {
    label: "Lustro matki",
    hint: "Boi się być jak mama albo widzi siebie w jej zachowaniu",
  },
  P3: {
    label: "Grzeczność / wina",
    hint: "Tłumaczy się, trudno powiedzieć „nie”, grzeczna córka",
  },
  P6: {
    label: "Opiekunka",
    hint: "Opiekuje chorującym rodzicem, wypalenie, placówka",
  },
  prosba_glosu: {
    label: "Chce głosu publicznego",
    hint: "Prosi o udostępnienie historii (anonimowo) na profil",
  },
};

export const MESSENGER_B_LABELS: Record<string, string> = {
  B1: "Boi się być jak matka",
  B2: "Lęk przy telefonie / ciało reaguje",
  B3: "Grzeczność, trudno powiedzieć nie",
  B4: "Poczucie winy",
  B5: "Ciało / wygląd",
  B6: "Babcia / wnuki",
  B7: "Opieka / wypalenie",
  B8: "Dorosła córka / wiek",
  B9: "Żałoba / strata",
  B10: "Tata / ojciec",
  B11: "Granice / karta",
  B12: "Konflikt / tarcie",
  B13: "Przemoc",
  B14: "Dom / wyprowadzka",
};

export const MESSENGER_TAG_LABELS: Record<string, string> = {
  przemoc: "Przemoc",
  opieka_choroba: "Opieka / choroba",
  babcia_dziadkowie: "Babcia / dziadkowie",
  wnuki: "Wnuki",
  tesciowa_swiekra: "Teściowa / świekra",
  tata_ojciec: "Tata / ojciec",
  partner_maz: "Partner / mąż",
  dzieci_wychowanie: "Dzieci / wychowanie",
  cialo_wyglad: "Ciało / wygląd",
  telefon_cisza: "Telefon / cisza",
  granice_odciecie: "Granice / odcięcie",
  wina_wstyd: "Wina / wstyd",
  zaloba: "Żałoba",
  alkohol: "Alkohol",
  terapia: "Terapia / psychika",
  pieniadze: "Pieniądze",
  ksiazka_produkt: "Książka / produkt",
  prosba_udostepnienia: "Prośba o udostępnienie",
  za_granica: "Za granicą",
  echo_lustro: "Nie chce być jak matka",
  obrona_matki: "Obrona matki",
  wsparcie_kasi: "Wsparcie dla Kasi",
  prosba_pomocy: "Prośba o pomoc",
  narcyzm: "Narcyzm (język autora)",
  toksyczn: "Toksyczna relacja",
  ksiazka_zakup: "Zakup książki",
  mama_matka: "Mama / matka",
  tata: "Tata",
};

const MONTH_NAMES = [
  "styczeń",
  "luty",
  "marzec",
  "kwiecień",
  "maj",
  "czerwiec",
  "lipiec",
  "sierpień",
  "wrzesień",
  "październik",
  "listopad",
  "grudzień",
];

export function messengerClassLabel(key: string): string {
  return MESSENGER_CLASS_LABELS[key]?.label ?? key.replace(/_/g, " ");
}

export function messengerClassHint(key: string): string {
  return MESSENGER_CLASS_LABELS[key]?.hint ?? "";
}

export function messengerPersonaLabel(key: string): string {
  return MESSENGER_PERSONA_LABELS[key]?.label ?? key;
}

export function messengerPersonaHint(key: string): string {
  return MESSENGER_PERSONA_LABELS[key]?.hint ?? "";
}

export function messengerBLabel(key: string): string {
  return MESSENGER_B_LABELS[key] ?? key;
}

export function messengerTagLabel(key: string): string {
  return MESSENGER_TAG_LABELS[key] ?? key.replace(/_/g, " ");
}

export function formatMessengerMonth(ym: string): string {
  const [y, m] = ym.split("-");
  const mi = parseInt(m, 10);
  if (!y || mi < 1 || mi > 12) return ym;
  return `${MONTH_NAMES[mi - 1]} ${y}`;
}

/** Kolejność klas w filtrach (najważniejsze dla marki na górze). */
export const CLASS_FILTER_ORDER = [
  "historia_identyfikacja",
  "produkt_zakup",
  "pytanie",
  "wsparcie",
  "atak_forma",
  "obrona_matek",
  "cta_only",
  "krotka_reakcja",
  "inne",
  "empty",
];

export const PERSONA_FILTER_ORDER = ["P1", "P2", "P6", "P3", "prosba_glosu"];

/** Soft pill colors per message class (light panel). */
export const MESSENGER_CLASS_STYLES: Record<string, string> = {
  historia_identyfikacja: "bg-violet-100 text-violet-800 border-violet-200",
  produkt_zakup: "bg-emerald-100 text-emerald-800 border-emerald-200",
  pytanie: "bg-sky-100 text-sky-800 border-sky-200",
  wsparcie: "bg-pink-100 text-pink-800 border-pink-200",
  atak_forma: "bg-orange-100 text-orange-800 border-orange-200",
  obrona_matek: "bg-amber-100 text-amber-900 border-amber-200",
  cta_only: "bg-slate-100 text-slate-700 border-slate-200",
  krotka_reakcja: "bg-slate-100 text-slate-600 border-slate-200",
  inne: "bg-slate-100 text-slate-600 border-slate-200",
  empty: "bg-slate-100 text-slate-500 border-slate-200",
};

export function messengerClassStyle(key: string): string {
  return MESSENGER_CLASS_STYLES[key] ?? "bg-slate-100 text-slate-700 border-slate-200";
}

export function formatStoryDate(dateStr: string): string {
  const parts = (dateStr || "").split("-").map(Number);
  if (parts.length < 3) return dateStr;
  const [y, m, d] = parts;
  if (!y || m < 1 || m > 12 || !d) return dateStr;
  return `${d} ${MONTH_NAMES[m - 1]} ${y}`;
}

export type QuickViewId =
  | "all"
  | "historia"
  | "voice"
  | "pytanie"
  | "wsparcie"
  | "produkt"
  | "opiekunka"
  | "kupili";

export const MESSENGER_QUICK_VIEWS: {
  id: QuickViewId;
  label: string;
  description: string;
}[] = [
  { id: "all", label: "Wszystkie", description: "Historie + opinie / głos" },
  {
    id: "historia",
    label: "Historie z życia",
    description: "Długie opowieści o relacji z matką",
  },
  {
    id: "voice",
    label: "Opinie i głos",
    description: "Pomiędzy historią a FAQ: opinie, ton, wsparcie",
  },
  {
    id: "pytanie",
    label: "Pytania",
    description: "Szuka rady lub wyjaśnienia",
  },
  {
    id: "wsparcie",
    label: "Wsparcie",
    description: "Wdzięczność, polecenia, ciepły ton",
  },
  {
    id: "produkt",
    label: "Pytania o produkt",
    description: "Książka, pakiet, jak kupić",
  },
  {
    id: "opiekunka",
    label: "Opiekunki",
    description: "Choroba rodzica, wypalenie",
  },
  {
    id: "kupili",
    label: "Już kupiły",
    description: "E-mail z DM w Easycart",
  },
];

export function dedupeStoryTopicLabels(story: {
  tags?: string[];
  b_signals?: string[];
}): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const t of story.tags ?? []) {
    const label = messengerTagLabel(t);
    if (!seen.has(label)) {
      seen.add(label);
      out.push(label);
    }
  }
  for (const b of story.b_signals ?? []) {
    const label = messengerBLabel(b);
    if (!seen.has(label)) {
      seen.add(label);
      out.push(label);
    }
  }
  return out;
}
